import { Button, ButtonProps } from '@mui/material'
import { FC } from 'react'

interface ButtonFieldLightProps extends ButtonProps {
  children?: React.ReactNode
  startIcon: any
  style?: {
    height: string
    borderRadius: string
    minWidth: string
    opacity?: number
  }
  name: string
  onClick?: any
  sxText?: ButtonProps['sx']
}

const ButtonFieldLight: FC<ButtonFieldLightProps> = ({
  startIcon,
  style,
  name,
  onClick,
  sxText,
  sx,
  ...rest
}) => {
  return (
    <Button
      id="basic-button"
      aria-haspopup="true"
      startIcon={startIcon}
      onClick={onClick}
      variant="secondary"
      sx={{
        ...style,
        ...sx,
      }}
      {...rest}
    >
      {name}
    </Button>
  )
}

export default ButtonFieldLight
